import { FormGroup, H5 } from '@blueprintjs/core';
import * as React from 'react';

import { ClassSelector } from 'src/components/ClassSelector';
import { ResourceSelector } from 'src/components/ResourceSelector';
import { useProjectResourceSuggestionsData } from 'src/containers/ProjectResourceSuggestionsDialog/projectResourceSuggestionsData';
import { projectClassItemsSelector } from 'src/selectors/projectClassItems';
import * as copy from 'src/templates/copy';
import { useReduxSelector } from 'src/utils/hooks/useReduxSelector';
import { useRouterParams } from 'src/utils/hooks/useRouterParams';

export const ProjectResourceSelectionPanel: React.VFC = () => {
  const { projectId } = useRouterParams();
  const {
    selectedClasses,
    selectedResources,
    setSelectedClasses,
    setSelectedResources,
  } = useProjectResourceSuggestionsData();
  const classItems = useReduxSelector(projectClassItemsSelector(projectId));
  return (
    <>
      <FormGroup
        label={
          <H5>
            {copy.components.resourceSuggestionsDialog.selection.resourcesLabel}
          </H5>
        }
      >
        <ResourceSelector
          selected={selectedResources}
          setSelected={setSelectedResources}
        />
      </FormGroup>
      {classItems.length ? (
        <FormGroup
          label={
            <H5>
              {copy.components.resourceSuggestionsDialog.selection.classesLabel}
            </H5>
          }
          subLabel={
            copy.components.resourceSuggestionsDialog.selection
              .classesHelperText
          }
        >
          <ClassSelector
            selected={selectedClasses}
            setSelected={setSelectedClasses}
          />
        </FormGroup>
      ) : null}
    </>
  );
};
